import React from 'react';
import Obfuscate from "react-obfuscate";

function EmailAddress() {
  return <Obfuscate
      email="2024@jamesfawcett.co.uk"
      headers={{
        // cc: "dade@zero-cool.af",
        subject: "Contact from jamesfawcett.co.uk",
        body: "Hi James"
      }}
    />
}
export default EmailAddress;